export default __webpack_public_path__ + "static/media/FAQ_7_2.e9f8bdde.png";